import { render, staticRenderFns } from "./user-password.vue?vue&type=template&id=6d8a6bac&scoped=true&"
import script from "./user-password.vue?vue&type=script&lang=js&"
export * from "./user-password.vue?vue&type=script&lang=js&"
import style0 from "./user-password.vue?vue&type=style&index=0&id=6d8a6bac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8a6bac",
  null
  
)

export default component.exports